export {
    AgilePageLayout,
    type AgilePageLayoutProps
} from "./agile-page-layout";
export { AgilePageLayout as default } from "./agile-page-layout";
